import { Fragment, useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  CustomInput,
  FormGroup,
  Label,
  Media,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import Proof from "./Proof";
import "@styles/base/pages/app-ecommerce.scss";
import { getCourses, saveTransactionPaymentProof } from "../../action";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  ArrowRight,
  CreditCard,
  FilePlus,
  FileText,
} from "react-feather";
import Cleave from "cleave.js/react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import UILoader from "@components/ui-loader";
import { saveCourseRegistration } from "../../action/index";
import { useForm } from "react-hook-form";
import { validateFileImage } from "@pageUtils/validate";
import PaymentDetails from "../PaymentDetails";
import PaymentDetailsV2 from "../PaymentDetailsV2";
import getResizeImage from "@pageUtils/resizeImageV2";
import {Thai} from "flatpickr/dist/l10n/th";
import Flatpickr from "react-flatpickr";
import { getTimeHHMI, toThaiLocalISOString } from "../../../../../utility/Utils";
import Select from "react-select";
import bankList from "../../../../../data/banks.json";

const MySwal = withReactContent(Swal);

const handleConfirmText = ({ callbackFunction, title, text , button1, button2}) => {

  if(!button1) {
    button1 = "ตกลง";
  }

  if(!button2) {
    button2 = "ปิด";
  }

  MySwal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: button1,
    cancelButtonText: button2,
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then(function (result) {
    if (result.value) {
      callbackFunction();
    }
  });
};

const confirmRegistrationSuccess = ({ title }) => {
  MySwal.fire({
    title: title,
    text: "",
    icon: "success",
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const confirmRegistrationError = ({ statusCode, statusDesc }) => {
  MySwal.fire({
    title: "บันทึกข้อมูลไม่สำเร็จ",
    text: statusDesc,
    icon: "error",
    confirmButtonText: "ตกลง",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const PaymentProof = (props) => {
  const options = { numeral: true, numeralThousandsGroupStyle: "thousand" };
  const { register, errors, handleSubmit, trigger } = useForm();

  const {
    data,
    payment,
    transactionCourseUser,
    transactionPaymentProofs,
    transactionCourseUserAddress,
    getCourseDetail,
    courseId,
    dispatch,
    stepper,
    receiptDate,
    setReceiptDate,
    address1,
    setAddress1,
    address2,
    setAddress2,
  } = props;

  const divError = {
    border: "1px solid",
    borderColor: "red",
    borderRadius: "5px",
  };

  const [activeView, setActiveView] = useState("grid");
  const [formModalProof, setFormModalProof] = useState(false);
  const [formModalPropertyFlag, setFormModalPropertyFlag] = useState(false);

  const [imageProofClassName, setImageProofClassName] = useState(null);
  const [imagePropertyClassName, setImagePropertyClassName] = useState(null);

  const [fileBase64, setFileBase64] = useState(null);
  const [fileBase64Property, setFileBase64Property] = useState(null);
  const [amount, setAmount] = useState(null);
  const [approveDate, setApproveDate] = useState(null);
  const [approveDateTime, setApproveDateTime] = useState(null);
  const [block, setBlock] = useState(false);
  const [customFileBrowserError, setCustomFileBrowserError] = useState("");
  const [amountError, setAmountError] = useState("");
  const refCustomFileBrowser = useRef(null);
  const [disabledDelete, setDisabledDelete] = useState(
    data &&
      transactionCourseUser &&
      transactionCourseUser.status === "WAIT_PAYMENT"
  );
  const [approveDateClassName, setApproveDateClassName] = useState("");
  const [approveDateTimeClassName, setApproveDateTimeClassName] = useState("");
  const [themeBankName, setThemeBankName] = useState(false);
  const inputBankElRef = useRef();
  const [inputBankDefault, setInputBankDefault] = useState(getBankDefault(null));
  const [bankName, setBankName] = useState(null);

  const [fileNameProof, setFileNameProof] = useState("เลือกไฟล์");
  const [fileNameProperty, setFileNameProperty] = useState("เลือกไฟล์");

  function getBankDefault(value) {
    let inputBank = [{ value: null, label: "กรุณาเลือก" }];
    bankList.map((item) => {
      if (value === item.value) {
        inputBank = [item];
      }
    });
    return inputBank;
  }

  function callBackFunction({ type, data }) {
    setBlock(false);
    if (data.statusCode === "0" || data.statusCode === 0) {
      handleConfirmText({
        callbackFunction: saveCourseRegistrationAction,
        title: "บันทึกข้อมูลเรียบร้อย",
        text: "กรณี \"ยืนยันการชำระเงิน\" จะไม่สามารถเพิ่มหลักฐานได้",
        button1:"ยืนยันการชำระเงิน",
        button2:"ต้องการเพิ่มหลักฐานอื่นๆ"
      });
      // confirmRegistrationSuccess({ title: "บันทึกข้อมูลเรียบร้อย" });
      dispatch({ type: type, data: data });
      setFileBase64(null);
      setAmount(null);
      setFileNameProperty("เลือกไฟล์");
      setFileNameProof("เลือกไฟล์");
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  }

  const saveProof = () => {
    let foundError = false;
    if (fileBase64 === null) {
      foundError = true;
      setCustomFileBrowserError("is-invalid");
      setImageProofClassName(divError);
    } else {
      setCustomFileBrowserError("");
      setImageProofClassName(null);
    }

    if (amount === null) {
      foundError = true;
      setAmountError("is-invalid");
    } else {
      setAmountError("");
    }

    if (approveDate === null) {
      foundError = true;
      setApproveDateClassName("is-invalid");
    } else {
      setApproveDateClassName("");
    }

    if (approveDateTime === null) {
      foundError = true;
      setApproveDateTimeClassName("is-invalid");
    } else {
      setApproveDateTimeClassName("");
    }

    if (bankName === null) {
      foundError = true;
      setThemeBankName(true);
    } else {
      setThemeBankName(false);
    }

    if (foundError) {
      return;
    }

    setFormModalProof(!formModalProof);

    const transactionPaymentProof = {
      id: null,
      transactionCourseUserId: transactionCourseUser.id,
      courseId: transactionCourseUser.courseId,
      userId: transactionCourseUser.userId,
      imageProof: fileBase64,
      amount: Number(amount.replace(/[^0-9.-]+/g, "")),
      bankName: bankName,
      transferDate: approveDate ? toThaiLocalISOString(approveDate) : null,
      transferTime: approveDateTime ? approveDateTime : null,
      flag: "1",
      fileType: "PROOF",
      callBackFunction: callBackFunction,
    };
    saveTransactionPaymentProof(transactionPaymentProof);
  };

  const saveProperty = () => {
    let foundError = false;
    if (fileBase64Property === null) {
      foundError = true;
      setImagePropertyClassName(divError);
    } else {
      setImagePropertyClassName(null);
    }

    if (foundError) {
      return;
    }

    setFormModalPropertyFlag(!formModalPropertyFlag);

    const transactionPaymentProof = {
      id: null,
      courseId: transactionCourseUser.courseId,
      transactionCourseUserId: transactionCourseUser.id,
      userId: transactionCourseUser.userId,
      imageProof: fileBase64Property,
      amount: 0,
      flag: "1",
      fileType: "PROPERTY",
      callBackFunction: callBackFunction,
    };
    saveTransactionPaymentProof(transactionPaymentProof);
  };

  function callBackFunctionRegistration({ type, data }) {
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({ title: "ยืนยันการชำระเงินเรียบร้อย" });
      dispatch({ type: type, data: data });
      setDisabledDelete(false);
      setReceiptDate(
        data &&
          data.transactionCourseUserAddress &&
          data.transactionCourseUserAddress.receiptDate
          ? new Date(data.transactionCourseUserAddress.receiptDate)
          : null
      );
      setAddress1(
        data &&
          data.transactionCourseUserAddress &&
          data.transactionCourseUserAddress.address1
          ? data.transactionCourseUserAddress.address1
          : null
      );
      setAddress2(
        data &&
          data.transactionCourseUserAddress &&
          data.transactionCourseUserAddress.address2
          ? data.transactionCourseUserAddress.address2
          : null
      );
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  }

  function saveCourseRegistrationActionConfirm() {
    saveCourseRegistration({
      courseId: data.id,
      userId: transactionCourseUser.userId,
      dispatch: dispatch,
      transactionCourseUserStatus: "WAIT_ADMIN_APPROVE",
      callBackFunction: callBackFunctionRegistration,
    });
  }

  function saveCourseRegistrationAction() {
    handleConfirmText({
      callbackFunction: saveCourseRegistrationActionConfirm,
      title: "ต้องการยืนยันการชำระเงิน ใช่หรือไม่",
      text: "",
    });
  }

  const genBase64 = (e) => {
    let fileUpload = e.target.files[0];
    if (fileUpload && !validateFileImage({ fileUpload })) {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(fileUpload);
      reader.onload = () => {
        getResizeImage(reader.result, setFileBase64);
        setImageProofClassName(null);
        setFileNameProof(fileUpload.name);
      };
    } else {
      setFileBase64(null);
      e.target.value = null;
      setFileNameProof("เลือกไฟล์");
    }
  };

  const genBase64Property = (e) => {
    let fileUpload = e.target.files[0];
    if (fileUpload && !validateFileImage({ fileUpload })) {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(fileUpload);
      reader.onload = () => {
        getResizeImage(reader.result, setFileBase64Property);
        setImagePropertyClassName(null);
        setFileNameProperty(fileUpload.name);
      };
    } else {
      setFileBase64Property(null);
      e.target.value = null;
      setFileNameProperty("เลือกไฟล์");
    }
  };

  const printLink = () => {
    return (
      "/receipt/" +
      (transactionCourseUser && transactionCourseUser.courseId
        ? transactionCourseUser.courseId
        : "") +
      "/" +
      (transactionCourseUser && transactionCourseUser.userId
        ? transactionCourseUser.userId
        : "")
    );
  };

  function NewlineText(props) {
    const text = props.text;
    return text.split("\n").map((str) => <p>{str}</p>);
  }

  function setApproveDateFunction(value) {
    setApproveDate(value);
    setApproveDateClassName("");
  }

  function setApproveDateTimeFunction(value) {
    let getDate = getTimeHHMI(value[0]);
    setApproveDateTime(getDate);
    setApproveDateTimeClassName("");
  }

  function setBankNameFunction(value) {
    setBankName(value);
    setThemeBankName(false);
  }

  return (
    <Fragment>
      <UILoader blocking={block} overlayColor="rgba(255,255,255, .5)">
        <div className="ecommerce-application">
          {Object.keys(data).length ? (
            <PaymentDetailsV2
              payment={payment}
              dispatch={dispatch}
              courseId={courseId}
              getCourseDetail={getCourseDetail}
              data={data}
              transactionCourseUser={transactionCourseUser}
              transactionPaymentProofs={transactionPaymentProofs}
            />
          ) : null}
          {transactionCourseUser && transactionCourseUser.remark ? (
            <Row className="my-2">
              <Col
                className="align-items-center justify-content-center mb-2 mb-md-0"
                md="6"
                xs="12"
              >
                <h6 className="mb-0">ข้อความที่ต้องการส่งถึงผู้ลงทะเบียน</h6>
                <br />
                <NewlineText text={transactionCourseUser.remark} />
              </Col>
            </Row>
          ) : null}
          <Proof
            data={data}
            setBlock={setBlock}
            payment={payment}
            dispatch={dispatch}
            activeView={activeView}
            setActiveView={setActiveView}
            getCourses={getCourses}
            transactionPaymentProofs={transactionPaymentProofs}
            disabledDelete={disabledDelete}
            setDisabledDelete={setDisabledDelete}
          />
        </div>
        {transactionCourseUser &&
        (transactionCourseUser.status === "PAYMENT_SUCCESS" ||
          transactionCourseUser.status === "APPROVE_SUCCESS" ||
          transactionCourseUser.status === "CANCEL" ||
          transactionCourseUser.status === "WAIT_ADMIN_APPROVE") ? (
          <Link
            className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0 btn btn-outline-primary"
            to="/payment"
          >
            <ArrowLeft className="mr-50" size={14} />
            กลับ
          </Link>
        ) : (
          <Button
            color="outline-primary"
            className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
            onClick={() => stepper.previous()}
          >
            <ArrowLeft className="mr-50" size={14} />
            กลับ
          </Button>
        )}
        {transactionCourseUser &&
        (transactionCourseUser.status === "PAYMENT_SUCCESS" ||
          transactionCourseUser.status === "WAIT_ADMIN_APPROVE") ? (
          <Button
            color="primary"
            className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
            onClick={() => stepper.next()}
          >
            ข้อมูลใบเสร็จ <ArrowRight className="mr-50" size={14} />
          </Button>
        ) : null}
        {Object.keys(data).length &&
        data.propertyFlag !== null &&
        data.propertyFlag === true &&
        transactionCourseUser &&
        transactionCourseUser.status === "WAIT_PAYMENT" ? (
          <Button
            color="outline-primary"
            className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
            onClick={() => setFormModalPropertyFlag(!formModalPropertyFlag)}
          >
            <FilePlus className="mr-50" size={14} />
            เพิ่มหลักฐานคุณสมบัติ
          </Button>
        ) : null}
        {Object.keys(data).length &&
        transactionCourseUser &&
        transactionCourseUser.status === "WAIT_PAYMENT" ? (
          <Button
            color="primary"
            className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
            onClick={() => setFormModalProof(!formModalProof)}
          >
            <FilePlus className="mr-50" size={14} />
            เพิ่มหลักฐานยืนยันการชำระเงิน
          </Button>
        ) : null}
        {transactionPaymentProofs &&
        transactionPaymentProofs.length &&
        transactionPaymentProofs.length > 0 &&
        payment &&
        payment.transactionCourseUser &&
        payment.transactionCourseUser.status === "WAIT_PAYMENT" ? (
          <Button
            color="success"
            className="btn-cart mr-0 mr-sm-1 mb-1 mb-sm-0"
            onClick={() => saveCourseRegistrationAction()}
          >
            <CreditCard className="mr-50" size={14} />
            ยืนยันการชำระเงิน
          </Button>
        ) : null}
      </UILoader>
      <Modal
        isOpen={formModalProof}
        toggle={() => setFormModalProof(!formModalProof)}
        className="modal-dialog-centered modal-lg"
      >
        <ModalHeader toggle={() => setFormModalProof(!formModalProof)}>
          เพิ่มหลักฐานยืนยันการชำระเงิน
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="fileUploadText">เลือกไฟล์รูปภาพที่จะ Upload</Label>
            <div style={imageProofClassName}>
              <div className="custom-file">
                <input
                  ref={refCustomFileBrowser}
                  type="file"
                  id="customFileBrowser"
                  name="customFileBrowser"
                  accept="image/*"
                  className="custom-file-input"
                  onChange={(e) => genBase64(e)}
                />
                <label
                  className="custom-file-label"
                  htmlFor="customFileBrowser"
                >
                  {fileNameProof}
                </label>
              </div>
            </div>
          </FormGroup>
          <FormGroup>
            <Label for="amount">
              จำนวนเงินที่ชำระ (กรุณาระบุยอดให้ตรงกับไฟล์หลักฐาน)
            </Label>
            <Cleave
              type="text"
              id="amount"
              placeholder="ยอดเงินที่ชำระ"
              className={"form-control " + amountError}
              options={options}
              innerRef={register({ required: true })}
              onChange={(e) => setAmount(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="amount">
              ธนาคารที่ท่านใช้โอน
            </Label>
            <Select
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#7367f01a", // for option hover bg-color
                    primary: "#7367f0", // for selected option bg-color
                    neutral10: "#7367f0", // for tags bg-color
                    neutral20: themeBankName ? "#ea5455" : "#d8d6de", // for input border-color
                    neutral30: themeBankName ? "#ea5455" : "#d8d6de", // for input hover border-color
                  },
                })}
                isClearable={false}
                id={"bankName"}
                classNamePrefix="select"
                options={bankList}
                ref={inputBankElRef}
                defaultValue={inputBankDefault}
                onChange={(e) => setBankNameFunction(e.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="approveDate">
              วันที่โอน (ระบุ ค.ศ.)
            </Label>
            <Flatpickr
                type={"text"}
                className={
                    "flatpickr-input form-control " + approveDateClassName
                }
                id="approveDate"
                value={approveDate}
                onChange={(date) => setApproveDateFunction(date[0])}
                placeholder="DD/MM/YYYY"
                options={{
                  disableMobile: "true",
                  dateFormat: "d/m/Y",
                  locale: Thai,
                  isBuddhist: "true",
                }}
            />
          </FormGroup>
          <FormGroup>
            <Label for="approveDateTime">
              เวลาโอน
            </Label>
            <Flatpickr
                className={
                    "flatpickr-input form-control " + approveDateTimeClassName
                }
                value={approveDateTime}
                id="approveDateTime"
                placeholder="HH:MI"
                type={"text"}
                options={{
                  enableTime: true,
                  noCalendar: true,
                  dateFormat: "H:i",
                  time_24hr: true,
                }}
                onChange={(date) => setApproveDateTimeFunction(date)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setFormModalProof(!formModalProof)}
          >
            ปิด
          </Button>
          <Button color="primary" onClick={() => saveProof()}>
            บันทึก
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={formModalPropertyFlag}
        toggle={() => setFormModalPropertyFlag(!formModalPropertyFlag)}
        className="modal-dialog-centered modal-lg"
      >
        <ModalHeader
          toggle={() => setFormModalPropertyFlag(!formModalPropertyFlag)}
        >
          เพิ่มหลักฐานคุณสมบัติ
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="fileUploadText">เลือกไฟล์รูปภาพที่จะ Upload</Label>
            <div style={imagePropertyClassName}>
              <div className="custom-file">
                <input
                  ref={refCustomFileBrowser}
                  type="file"
                  id="customFileBrowserProperty"
                  name="customFileBrowserProperty"
                  accept="image/*"
                  className="custom-file-input"
                  onChange={(e) => genBase64Property(e)}
                />
                <label
                  className="custom-file-label"
                  htmlFor="customFileBrowser"
                >
                  {fileNameProperty}
                </label>
              </div>
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setFormModalPropertyFlag(!formModalPropertyFlag)}
          >
            ปิด
          </Button>
          <Button color="primary" onClick={() => saveProperty()}>
            บันทึก
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
export default PaymentProof;
